module.exports = __webpack_public_path__ + "static/tax-benefit-be2a7009646c5ffa49ff55d05400d52e.svg";